import { axiosInstances } from '../../../utilities/axios/Instances/axios.instances';
const search = (name = '') => {
  return axiosInstances.withAuthToken().get(`/tags/${name ? `?name=${name}` : ''}`);
};
export const TagsService = { search };
